import { TabletShell, Timeline, EXISTING } from "./tablet";
import { Chip, Button } from "./primitives";
import { PLAN } from "./data";

export default function S4() {
  return (
    <TabletShell id="s4" active="Requests">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
        <div className="serif" style={{ fontSize: 76, fontWeight: 500, lineHeight: 1 }}>Good evening, Aura</div>
        <div style={{ fontSize: 28, color: "var(--ink-60)" }}>Tuesday · 6:05 PM</div>
      </div>

      <div style={{ marginTop: 60, display: "flex", alignItems: "center", gap: 18 }}>
        <span style={{ width: 18, height: 18, borderRadius: "50%", background: "var(--burgundy)" }} />
        <span style={{ fontSize: 30, fontWeight: 600 }}>New request</span>
        <span style={{ fontSize: 26, color: "var(--ink-40)" }}>via marova · just now</span>
      </div>

      <div style={{ marginTop: 24, background: "#fff", borderRadius: 36, border: "2px solid var(--burgundy)", padding: "44px 48px", boxShadow: "0 30px 70px -50px rgba(109,36,51,.5)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
          <span style={{ width: 84, height: 84, borderRadius: "50%", background: "var(--blush)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 34, fontWeight: 600, color: "var(--burgundy)" }}>S</span>
          <div>
            <div style={{ fontSize: 40, fontWeight: 600 }}>{PLAN.customer}</div>
            <div style={{ fontSize: 28, color: "var(--ink-60)" }}>New client · 2 services · same visit</div>
          </div>
          <div style={{ marginLeft: "auto", fontSize: 44, fontWeight: 600 }}>${PLAN.total}</div>
        </div>
        <div style={{ display: "flex", gap: 14, flexWrap: "wrap", marginTop: 34 }}>
          <Chip tone="mint" size={26}>Hydrating Facial · 60 min</Chip>
          <Chip tone="lilac" size={26}>Brow Shaping · 20 min</Chip>
          <Chip tone="blush" size={26}>{PLAN.window}</Chip>
        </div>
        <div style={{ marginTop: 36, padding: "26px 30px", borderRadius: 20, background: "var(--porcelain)", fontSize: 28, color: "var(--ink-60)", lineHeight: 1.45 }}>
          “{PLAN.request}”
        </div>
        <div style={{ display: "flex", gap: 20, marginTop: 40 }}>
          <Button size={30} style={{ flex: 1 }}>Suggest a plan</Button>
          <Button size={30} tone="ghost" style={{ width: 300 }}>Decline</Button>
        </div>
      </div>

      <div style={{ marginTop: 70, fontSize: 30, fontWeight: 600 }}>Tonight’s schedule</div>
      <Timeline slots={EXISTING} height={620} />
    </TabletShell>
  );
}
